import '../styles/learn.scss';

function Learn() {
  return (
    <div className='learn'>
      <div className='learn-card'>
        <span className='emoji'>🛠️</span>
        <h1>Under Construction</h1>
        <p>
          This section is still being built.
          <br />
          Check back soon for lessons, exercises, and tools.
        </p>
      </div>
    </div>
  );
}

export default Learn;